<div class="row pt-0">
    <div class="col-12">
        <ngx-loading [show]="loadingIndicator"></ngx-loading>
        <div class="row pt-0 col-md-12">
            <div class="input-group ">
                <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="openContactModal(null)" placement="bottom" ngbTooltip="Add New Contact">
                    <i class="fa fa-lg fa-plus"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Add Contact</span>
                </button>
               
                <button type="button" class="btn btn-sm btn-secondary tt mb-1 mr-1" (click)="print()" placement="bottom" [disabled]="count < 1"
                    ngbTooltip="Print List">
                    <i class="fa fa-lg fa-print"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Print</span>
                </button>

                <div class="btn-group mr-1">
                    <button type="button" class="btn btn-sm btn-secondary dropdown-toggle mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="count < 1">
                        <i class="fa fa-lg fa-download"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Export</span>
                    </button>
                    <div class="dropdown-menu fs-12">
                        <a (click)="peopleContacts_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
                        <a (click)="peopleContacts_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
                        <a (click)="peopleContacts_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
                    </div>
                </div>

                <button type="button" [ngClass]="(showFilters)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
                    (click)="toggleFilters()" placement="bottom" ngbTooltip="Filter List">
                    <i class="fa fa-lg fa-filter"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Filter</span>
                </button>
                <button type="button" [ngClass]="(showSidebar)?'btn-success':'btn-secondary'" class="btn btn-sm mb-1 mr-1"
                    (click)="toggleSideBar()" placement="bottom" ngbTooltip="Toggle Sidebar">
                    <i class="fa fa-lg fa-toggle-right"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Sidebar</span>
                </button>
           
                <div class="btn-group mb-1">
                    <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <span class="sr-only">Toggle Dropdown</span>
                        <i class="fa fa-lg fa-check-square-o"></i><span *ngIf="themeSettings.menu_type == 'default'">&nbsp; Columns</span>
                    </button>
                    <div class="dropdown-menu fs-12" style="width: 150px;">
                        <div class="col-md-12 mb-3 fs-12">
                            <input type="checkbox" name="first_name" [(ngModel)]="showName"> Name<br />
                            <input type="checkbox" name="address" [(ngModel)]="showAddress"> Address<br />
                            <input type="checkbox" name="position" [(ngModel)]="showPosition"> Position<br />
                            <input type="checkbox" name="phone" [(ngModel)]="showPhone"> Phone<br />
                            <input type="checkbox" name="email" [(ngModel)]="showEmail"> Email<br />
                            <input type="checkbox" name="mobile" [(ngModel)]="showMobile"> Mobile #<br />
                            <input type="checkbox" name="fax" [(ngModel)]="showFax"> Fax<br />
                            <input type="checkbox" name="abn" [(ngModel)]="showABN"> ABN<br />
                        </div>
                    </div>
                </div>
            </div>
        </div><br/>

        <div class="row pt-0 col-md-12" *ngIf="showFilters">
            <div widget class="card border-0 box-shadow" *ngIf="showFilters">
                <div class="card-header border-0 text-muted">
                    <h5 class="mb-0">Search People Contacts:</h5>
                    <div class="widget-controls">
                        <a data-widgster="close" class="transition" (click)="toggleFilters()"><i class="fa fa-times"></i></a>
                    </div>
                </div>
                <div class="card-body card-header pt-0 widget-body">
                    <div class="row">
                        <div class="col-md-4">
                            <label>Full Name:</label>
                            <input type="text" class="form-control form-control-sm" (keyup)="updateFilter()"
                            [(ngModel)]="searchText">
                        </div>
                        <div class="col-md-4">
                            <label>Phone #:</label>
                            <input type="text" class="form-control form-control-sm" (keyup)="updateFilter()"
                            [(ngModel)]="filterPhone">
                        </div>
                        <div class="col-md-4">
                            <label>Address:</label>
                            <input type="text" class="form-control form-control-sm" (keyup)="updateFilter()"
                            [(ngModel)]="filterAddress">
                        </div>
                        <div class="col-md-4">
                            <label>Email:</label>
                            <input type="text" class="form-control form-control-sm" (keyup)="updateFilter()"
                            [(ngModel)]="filterEmail">
                        </div>
                        <div class="col-md-4">
                            <label>Position:</label>
                            <input type="text" class="form-control form-control-sm" (keyup)="updateFilter()"
                            [(ngModel)]="filterPosition">
                        </div>
                    </div>
                    <br />
                    <div class="row" *ngIf="!isFilterEmpty">
                        <div class="col-md-12">
                            <button type="button" class="btn btn-success btn-sm mb-1" (click)="resetFilters()">
                                <span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-filter"></i></span>
                                <span>Reset Filters</span>
                            </button> &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div> <br *ngIf="showFilters" />
<!-- START OF LIST TABLE -->
   
    <div *ngIf="tableType=='list'" class="row pt-0 mt-0">
        <div [ngClass]="(showSidebar) ? 'col-md-6' : 'col-md-12'">
            <ngx-datatable 
            class="material" 
            [rows]="rows" 
            [columnMode]="'force'" 
            [headerHeight]="30" 
            [footerHeight]="40"
            [rowHeight]="'auto'" 
            [limit]="30" 
            [selectionType]="'single'" 
            [scrollbarH]="true"
            [selected]="selected"
            (select)='onSelect($event)'>

            <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="100" >
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div>
                        <a container="body" placement="top" title="Edit Contact" (click)="openContactModal(row)"><i
                                class="fa fa-lg fa-pencil"></i></a>&nbsp;
                        <a  (click)="openDeleteContactModal(row)" placement="right" title="Delete Contact"><i class="fa fa-lg fa-trash"></i></a>&nbsp;
                        <a *ngIf="filter == 'All'" container="body" placement="top" title="Add Affiliate to Contacts" (click)="openAffiliateModal(row, null)"><i
                            class="fa fa-lg fa-address-book-o"></i></a>
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="first_name" name="Name" headerClass="header" *ngIf="showName" [width]="180">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div align="left"
                        style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; ">
                        <span title="{{row.phone_no}}">{{row.first_name}} {{row.last_name}}</span>
                    </div>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="position" name="Position" headerClass="header" *ngIf="showPosition" [width]="180">
            </ngx-datatable-column>
            <ngx-datatable-column prop="address" name="Address" headerClass="header" *ngIf="showAddress" [width]="180">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div align="left" ngbTooltip="{{row.address}}" placement="bottom" container="body"
                        style="padding-right:5px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 100%; ">
                        <span title="{{row.phone_no}}" >{{row.address}}</span>
                    </div>
                </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column prop="phone" name="Phone" headerClass="header" *ngIf="showPhone" [width]="180">
            </ngx-datatable-column>
            <ngx-datatable-column prop="mobile" name="Mobile" headerClass="header" *ngIf="showMobile" [width]="180">
            </ngx-datatable-column>
            <ngx-datatable-column prop="email" name="Email" headerClass="header" *ngIf="showEmail" [width]="180">
            </ngx-datatable-column>
            <ngx-datatable-column prop="fax" name="Fax" headerClass="header" *ngIf="showFax" [width]="180">
            </ngx-datatable-column>
            <ngx-datatable-column prop="abn" name="ABN#" headerClass="header" *ngIf="showABN" [width]="180">
            </ngx-datatable-column>

            </ngx-datatable>
        </div>

        <!-- DETAILS SIDEBAR -->
        <div class="col-md-6" *ngIf="showSidebar">
            <div widget class="card border-0 box-shadow selected-column">
                <div class="card-header transparent border-0 text-muted">
                    <h5 class="mb-0">Contact Details:</h5>
                </div>
                <div class="card-body pt-0 widget-body" *ngIf="selected.length > 0">
                    <ul>
                        <div *ngFor='let sel of selected'>
                            <div class="col-md-12">
                                <div class="media">
                                    <div class="col-4">
                                        <img *ngIf="sel?.photo == null || sel?.photo == ''" class="d-flex mr-3" src="/assets/img/users/default-user.jpg" width="50">
                                        <img *ngIf="sel?.photo != null && sel?.photo != ''" class="d-flex mr-3" src="{{contacts_folder_path}}/{{sel?.photo}}" width="50">
                                    </div> &nbsp;
                                    <div class="col-8">
                                        <label class="titleHeader"><strong>{{sel["first_name"]}} {{sel["last_name"]}}</strong></label>
                                    </div>
                                </div><br/>
                                ABN: <strong>{{sel.abn}}</strong><br />
                                Position: <strong>{{sel.position}}</strong><br />
                                Email: <strong>{{sel.email}}</strong><br />
                                Address: <strong>{{sel.address}}</strong><br />
                                Phone: <strong>{{sel.phone}}</strong><br />
                                Mobile: <strong>{{sel.mobile}}</strong><br />
                                Fax: <strong>{{sel.fax}}</strong><br />
                               
                            </div><br />

                            <!-- Customer companies affiliation -->
                            
                            <div *ngIf="customer_company_affiliates.length">
                                <strong>Customer/s</strong>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th ><small><strong>Company Name</strong></small></th>
                                            <th><small><strong>Contact Type/s</strong></small></th>
                                            <th><small><strong>Phone</strong></small></th>
                                            <th><small><strong>Mobile</strong></small></th>
                                            <th><small><strong>Email</strong></small></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let c of customer_company_affiliates  | paginate: { itemsPerPage: 5, currentPage: cp} ; let i = index;" >
                                            <td><i class="fa fa-pencil" title="Update Affiliation" (click)="openAffiliateModal(sel, c)"></i>&nbsp;
                                                <i class="fa fa-trash" title="Delete Affiliation" (click)="openDeleteAffiliationModal(c)"></i></td>
                                            <td >{{c.company_name}}</td>
                                            <td>
                                                <div *ngFor="let cc of c.contact_types">
                                                    <div *ngIf="cc.company_contact_id !== 0">
                                                        {{cc.type_name}}  &nbsp; <i class="fa fa-envelope" style="color:green" *ngIf="cc.email_notification == 1"></i> <i class="fa fa-envelope" style="color:gray" *ngIf="cc.email_notification == 0"></i> &nbsp; <i class="fa fa-mobile" style="color:green" *ngIf="cc.sms_notification == 1"></i><i class="fa fa-mobile" style="color:gray" *ngIf="cc.sms_notification == 0"></i>
                                                    </div>    
                                                </div>
                                                
                                            </td>
                                            <td>{{c.dedicated_phone}}</td>
                                            <td>{{c.dedicated_mobile}}</td>
                                            <td>{{c.dedicated_email}}</td>

                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="bg-white text-center">
                                            <small><pagination-controls autoHide="true" (pageChange)="cp = $event" maxSize="10"></pagination-controls></small>
                                        </div>        
                                    </div>
                                </div> 
                            </div>
                            <br />
                            <!-- Suppliers companies affiliation -->
                           
                            <div *ngIf="supplier_company_affiliates.length">
                                <strong>Supplier/s</strong>
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th><small><strong>Company Name</strong></small></th>
                                            <th><small><strong>Contact Type/s</strong></small></th>
                                            <th><small><strong>Phone</strong></small></th>
                                            <th><small><strong>Mobile</strong></small></th>
                                            <th><small><strong>Email</strong></small></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let s of supplier_company_affiliates  | paginate: { itemsPerPage: 5, currentPage: sp} ; let i = index;">
                                            <td><i class="fa fa-pencil" title="Update Affiliation" (click)="openAffiliateModal(sel, s)">&nbsp;</i>
                                                <i class="fa fa-trash" title="Delete Affiliation" (click)="openDeleteAffiliationModal(s)"></i></td>
                                            <td>{{s.company_name}}</td>
                                            <td>
                                                <div *ngFor="let sc of s.contact_types">
                                                    <div *ngIf="sc.company_contact_id !== 0">
                                                        {{sc.type_name}}  &nbsp; <i class="fa fa-envelope" style="color:green" *ngIf="sc.email_notification == 1"></i><i class="fa fa-envelope" style="color:gray" *ngIf="sc.email_notification == 0"></i> &nbsp; <i class="fa fa-mobile" style="color:green" *ngIf="sc.sms_notification == 1"></i><i class="fa fa-mobile" style="color:gray" *ngIf="sc.sms_notification == 0"></i>
                                                    </div>
                                                </div>
                                                
                                            </td><td>{{s.dedicated_phone}}</td>
                                            <td>{{s.dedicated_mobile}}</td>
                                            <td>{{s.dedicated_email}}</td>

                                        </tr>
                                    </tbody>
                                </table>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="bg-white text-center">
                                            <small><pagination-controls autoHide="true" (pageChange)="sp = $event" maxSize="10"></pagination-controls></small>
                                        </div>        
                                    </div>
                                </div> 
                            </div>
                            
                        </div>
                        <li *ngIf="!selected.length">No Selections</li>
                    </ul>
                </div>
            </div>
        </div>
        <!--  END DETAILS SIDEBAR  -->
                    
    </div>
<!-- END OF LIST TABLE -->

<!-- START OF PAGINATION -->
    <div class="row">
        <div class="col-12">
            <div class="bg-white text-center">
                <pagination-controls autoHide="true" (pageChange)="p = $event" maxSize="10"></pagination-controls>
            </div>
        </div>
    </div>
<!-- END OF PAGINATION -->
      </div>
</div>


<!-- START PRINT-->
<div id="print-section" style="display:none">
    <table style="width:100%">
        <tr>
          <th align="left">NAME</th>
          <!-- <th align="left">COMPANY</th> -->
          <th align="left">POSITION</th>
          <th align="left">ADDRESS</th>
          <th align="left">PHONE</th>
          <th align="left">EMAIL</th>
          <th align="left">MOBILE</th>
          <th align="left">ABN</th>
          <th align="left">FAX</th>


        </tr>
        <tr *ngFor="let row of rows">
          <td>{{row.first_name}}&nbsp;{{row.last_name}}</td>
          <!-- <td>{{row.company}}</td> -->
          <td>{{row.position}} </td>
          <td>{{row.address}} </td>
          <td>{{row.phone}} </td>
          <td>{{row.mobile}} </td>
          <td>{{row.email}} </td>
          <td>{{row.abn}} </td>
          <td>{{row.fax}} </td>
            </tr>
    </table>
</div>
<!-- END PRINT -->


<!-- START OF ADD CONTACT FORM -->
<ng-template #modalContact let-close="close">
    <div class="modal-header">
        <h5 class="modal-title" *ngIf="isUpdateMode==false"><i class="fa fa-2x fa-user-plus text-success"></i> Add Contact</h5>
        <h5 class="modal-title" *ngIf="isUpdateMode==true"><i class="fa fa-2x fa-edit text-success"></i> Edit Contact</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="contactForm" novalidate (ngSubmit)="onSubmitContact(contactForm.value)">
        <div class="modal-body bg-gray">
            <div class="row col-md-12">
                <div class="col-md-4">
                    <div class="form-group" *ngIf ="(picContactExists==true)">
                        <label class="form-control-label">Contact Photo</label><br/>
                        <img *ngIf="(contact?.photo != '' && contact?.photo != 'nopic.png') && isUpdateMode==true" src="{{contacts_folder_path}}/{{contact?.photo}}" width="80">
                        <button class="btn btn-sm btn-primary" type="button" (click)="removePic('contact')">Remove Image</button>
                    </div>
                    <div class="form-group" *ngIf ="(picContactExists==false)">
                        <label class="form-control-label">Contact Photo</label>
                        <app-image-uploader (passImage)="getFile($event)"></app-image-uploader>
                    </div>
                </div>
            
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="input-1">Position:</label>
                        <input type="text" class="form-control form-control-sm" formControlName="position">
                    </div>
                </div>

            </div>

            <div class="row col-md-12">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="input-1">First Name<span class="text-danger">*</span>:</label>
                        <input type="text" class="form-control form-control-sm" formControlName="first_name" required>
                        <div *ngIf="contactForm.controls.first_name.touched">
                            <div *ngIf="contactForm.controls.first_name.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="input-1">Last Name<span class="text-danger">*</span>:</label>
                        <input type="text" class="form-control form-control-sm" formControlName="last_name" required>
                        <div *ngIf="contactForm.controls.last_name.touched">
                            <div *ngIf="contactForm.controls.last_name.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="input-1">Email<span class="text-danger">*</span>:</label>
                        <div class="input-group input-group-sm">
                            <div class="input-group-prepend"><div class="input-group-text">@</div></div>
                            <input type="text" class="form-control form-control-sm" formControlName="email">
                        </div>
                        <small class="text-danger" *ngIf=" contactForm.get('email').hasError('email')">Invalid email address</small>
                        <div *ngIf="contactForm.controls.email.touched">
                            <div *ngIf="contactForm.controls.email.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                            <div *ngIf="contactForm.controls.email.errors?.pattern ">
                                <small class="text-danger">Email must be a valid email address.</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row col-md-12">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="input-1">Address:</label>
                        <input type="text" class="form-control form-control-sm" formControlName="address">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="input-1">Phone:</label>
                        <div class=input-group>
                            <div class="input-group-prepend"><div class="input-group-text"><i class="fa fa-phone"></i></div></div>
                            <input type="text" class="form-control form-control-sm" pattern="[0-9]*" formControlName="phone">
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="input-1">Mobile:</label>
                        <div class=input-group>
                            <div class="input-group-prepend"><div class="input-group-text"><i class="fa fa-mobile-phone"></i></div></div>
                            <input type="text" class="form-control form-control-sm" pattern="[0-9]*" formControlName="mobile">
                        </div>
                    </div>
                </div>

            </div>
            <div class="row col-md-12">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label for="input-1">Fax:</label>
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend"><div class="input-group-text">#</div></div>
                                <input type="text" class="form-control form-control-sm" pattern="[0-9]*" formControlName="fax">
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                    <div class="form-group">
                        <label for="input-1">ABN:</label>
                        <input type="text" class="form-control form-control-sm" pattern="[0-9]*" formControlName="abn">
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button *ngIf="isUpdateMode==false" type="submit" class="btn btn-sm btn-success" [disabled]="!contactForm.valid || spinner == true ">Save</button>
            <button *ngIf="isUpdateMode==true" type="submit" class="btn btn-sm btn-success" [disabled]="!contactForm.valid || spinner == true">Save Changes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="close(); closeModal()" ngbAutofocus>Cancel</button>
        </div>
    </form>
</ng-template>

<!-- END OF ADD CONTACT FORM -->


<!-- START OF ADD AFFILIATIONS FORM -->
<ng-template #modalAffiliateContact let-close="close">
    <div class="modal-header">
        <h5 class="modal-title" *ngIf="isUpdateCa==false" ><i class="fa fa-2x fa-user-plus text-success"></i> Add Contact Affiliation</h5>
        <h5 class="modal-title" *ngIf="isUpdateCa==true"><i class="fa fa-2x fa-edit text-success"></i> Edit Contact Affiliation</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="affiliateForm" novalidate (ngSubmit)="onSubmitAffiliate(affiliateForm.value)">
        <div class="modal-body bg-gray">
            <div class="row col-md-12">
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="input-1">Company Type<span class="text-danger">*</span>: </label>
                        <select  class="form-control form-control-sm" formControlName="type" (change)="populateCompany()" [attr.disabled]="isUpdateCa? true : null">
                            <option selected disabled>Select..</option>
                            <option value="Customer">Customer</option>
                            <option value="Supplier">Supplier</option>
                        </select>
                        <div *ngIf="affiliateForm.controls.type.touched">
                            <div *ngIf="affiliateForm.controls.type.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label for="input-1">Company<span class="text-danger">*</span>:</label>
                        <select  class="form-control form-control-sm" formControlName="company_id" [attr.disabled]="isUpdateCa ? true : null">
                            <option selected disabled>Select..</option>
                            <option *ngFor="let company of companies" value="{{company.id}}">{{company.company_name}}</option>
                        </select>
                        <div *ngIf="affiliateForm.controls.company_id.touched">
                            <div *ngIf="affiliateForm.controls.company_id.errors?.required">
                                <small class="text-danger" >This field is required.</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            <div class="row col-md-12">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="input-1">Dedicated Phone No:</label>
                        <input type="text" class="form-control form-control-sm" pattern="[0-9]*" formControlName="dedicated_phone">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="input-1">Dedicated Mobile No:</label>
                        <input type="text" class="form-control form-control-sm" pattern="[0-9]*" formControlName="dedicated_mobile">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="input-1">Dedicated Email:</label>
                        <input type="text" class="form-control form-control-sm" formControlName="dedicated_email">
                        <div *ngIf="affiliateForm.controls.dedicated_email.touched">
                            <div *ngIf="affiliateForm.controls.dedicated_email.errors?.pattern ">
                                <small class="text-danger">Email must be a valid email address.</small>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div class="row col-md-12">
                <div class="col-md-12">
                    <div class="form-group">
                        <label for="input-1">Contact Type/s Configuration:</label>
                        <br/>
                        <div formArrayName="contact_types" class="form-inline col-8">
                            <span  class="col-md-12">
                                <table border="1" width="100%" style="color:gray">
                                    <thead>
                                        <tr>
                                            <th width="50%" align="center" style="color:gray">Contact Type</th>
                                            <th width="25%" align="center" style="color:gray">Enable Email Notification</th>
                                            <th width="25%" align="center" style="color:gray">Enable SMS Notification</th>
                                        </tr>
                                    </thead>
                                    
                                    <tbody *ngFor="let ct of affiliateForm.controls.contact_types['controls']; let i = index">
                                        <tr [formGroupName]="i">
                                            <td width="50%">&nbsp;&nbsp;
                                                <input  type="checkbox" formControlName="is_enabled" (click)="checkValue(ct.controls, $event)"> &nbsp;&nbsp; {{ct.controls.type_name.value}}
                                                <input formControlName="contact_type_id" type="hidden">
                                                <input formControlName="company_contact_id" type="hidden" value="company_contact_id">
                                            </td>
                                            <td width="25%" align="center">
                                                <input  formControlName="email_notification" type="checkbox" [attr.disabled]="ct.controls.is_enabled.value == 0? true:null"> 
                                            </td>
                                            <td width="25%" align="center">
                                                <input  formControlName="sms_notification" type="checkbox" [attr.disabled]="ct.controls.is_enabled.value == 0? true:null"> 
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </span>
                        </div>                       
                    </div>
                </div>
            </div>
        </div>        
        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button *ngIf="isUpdateCa==false" type="submit" class="btn btn-sm btn-success" [disabled]="!affiliateForm.valid || spinner == true">Save</button>
            <button *ngIf="isUpdateCa==true" type="submit" class="btn btn-sm btn-success" [disabled]="!affiliateForm.valid || spinner == true">Save Changes</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="close(); closeModal()" ngbAutofocus>Cancel</button>
        </div>
    </form>

</ng-template>

<!-- END OF ADD AFFILIATIONS FORM -->

<!-- START OF DELETE CONTACT FORM -->
<ng-template #modalDeleteContact let-close="close">
    <div class="modal-header">
        <h5 class="modal-title"><i class="fa fa-2x fa-danger text-danger"></i> Delete contact</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body bg-gray">
        <div class="row">
            <div class="col-md-12">
               * All customer and supplier company affiliations will also be deleted. 
               Do you really want to delete <strong>{{currentContact?.first_name}} {{currentContact?.last_name}}</strong>?
            </div>
        </div>

    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger"  (click)="deleteContact(currentContact.id)" [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE CONTACT FORM -->


<!-- START OF DELETE AFFILIATION FORM -->
<ng-template #modalDeleteAffiliation let-close="close">
    <div class="modal-header">
        <h5 class="modal-title"><i class="fa fa-2x fa-danger text-danger"></i> Delete Contact Affiliation</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body bg-gray">
        <div class="row">
            <div class="col-md-12">
               Do you really want to delete affilitaion to <strong>{{currentAffiliation?.company_name}} </strong> for <strong>{{currentContact?.first_name}} {{currentContact?.last_name}}</strong>?
            </div>
        </div>

    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger"  (click)="deleteAffiliation(currentAffiliation)" [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE AFFILIATION FORM -->